export default "__VITE_ASSET__DjRX4ZOK__"